import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { fontSize, minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading } from './ui';

const StyledTeamProfiles = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 30px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 40px;
  `}

  ${minBreakpointQuery.medium`
    margin-bottom: 50px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 60px;
  `}

  ${minBreakpointQuery.xxlarge`
    margin-bottom: 70px;
  `}

  ${minBreakpointQuery.xxxxlarge`
    margin-bottom: 80px;
  `}
`;

const StyledItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  row-gap: 30px;

  ${minBreakpointQuery.small`
    row-gap: 40px;
  `}

  ${minBreakpointQuery.medium`
    row-gap: 50px;
  `}

  ${minBreakpointQuery.large`
    row-gap: 60px;
  `}

  ${minBreakpointQuery.xxlarge`
    row-gap: 70px;
  `}

  ${minBreakpointQuery.xxxxlarge`
    row-gap: 80px;
  `}
`;

const StyledItem = styled.article`
  padding: 0 15px;
  width: 100%;
  text-align: center;

  ${minBreakpointQuery.tiny`
    width: 50%;
  `}

  ${minBreakpointQuery.smedium`
    width: calc(100% / 3);
  `}

  ${minBreakpointQuery.mlarge`
    width: 25%;
  `}
`;

const StyledImage = styled(GatsbyImage)``;

const StyledName = styled.h3`
  margin-top: 12px;
  ${fontSize(21)};

  ${minBreakpointQuery.small`
    margin-top: 16px;
    ${fontSize(23)};
  `}

  ${minBreakpointQuery.large`
    margin-top: 20px;
    ${fontSize(25)};
  `}
`;

const StyledRole = styled.p`
  margin-top: 4px;

  ${minBreakpointQuery.small`
    margin-top: 6px;
    ${fontSize(17)};
  `}

  ${minBreakpointQuery.large`
    margin-top: 8px;
    ${fontSize(18)};
  `}
`;

const TeamProfiles = ({ heading, items }) => (
  <StyledTeamProfiles>
    <Container>
      <StyledHeading alt={true}>{heading}</StyledHeading>
      <StyledItems>
        {items.map(({ image, name, role }, id) => (
          <StyledItem key={id}>
            <StyledImage image={image.gatsbyImageData} alt={image.alt} />
            <StyledName>{name}</StyledName>
            <StyledRole>{role}</StyledRole>
          </StyledItem>
        ))}
      </StyledItems>
    </Container>
  </StyledTeamProfiles>
);

export default TeamProfiles;
